import { render, staticRenderFns } from "./DevisProForma.vue?vue&type=template&id=5a92733d&scoped=true&"
import script from "./DevisProForma.vue?vue&type=script&lang=js&"
export * from "./DevisProForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a92733d",
  null
  
)

export default component.exports